import { useId } from "react";

// Drafting tools (set square, ruler, sheet). The tile paints the cut-outs in
// the tile colour over the glyph; the bare glyph masks them out instead.
const PRECON_GLYPH_PATHS = [
  "M15.6147 10.8724C15.6164 10.3953 15.5719 7.18571 15.694 7.01859C15.8672 6.93559 16.1499 7.15098 16.2684 7.26221C17.1693 8.10772 18.0378 8.98185 18.9148 9.85018L22.1579 13.0128L28.0271 18.7295C28.8553 19.5398 29.7018 20.3336 30.5185 21.1551C30.6857 21.3233 31.0795 21.6906 30.9866 21.9344C30.8234 22.052 28.1102 22.007 27.7191 22.0083L20.4139 22.0114L17.7131 22.0132C17.2314 22.0151 16.7077 22.0411 16.2339 21.9919C15.8486 21.9518 15.6405 21.6317 15.6323 21.2784C15.6085 20.2557 15.6077 19.2128 15.6203 18.1902C15.9543 18.1922 16.2881 18.1786 16.6208 18.1492L16.5607 17.8027C16.2451 17.7819 15.9284 17.7808 15.6126 17.7993C15.6156 17.4536 15.6219 17.1024 15.6203 16.7573C15.84 16.7833 16.5543 16.8469 16.6182 16.5743C16.4993 16.3377 15.8683 16.3872 15.6197 16.389L15.6146 15.3691C15.8116 15.3733 16.6173 15.4446 16.6274 15.1681C16.461 14.9339 15.883 14.9919 15.6205 14.9993C15.6179 14.7707 15.5982 14.1775 15.6205 13.9791C15.6671 13.8871 15.6401 13.7383 15.6309 13.6305C15.6037 13.5116 15.6207 12.79 15.6226 12.6308C15.6002 12.1634 15.5554 11.7545 15.5974 11.2816C15.6914 11.2344 16.3906 11.2654 16.5658 11.2607L16.5768 10.8998C16.2424 10.8794 15.9492 10.8744 15.6147 10.8724Z",
  "M7.21818 12.8918C7.86921 12.8347 9.17361 12.8729 9.86946 12.8786C9.84651 13.1111 9.85674 13.411 9.88053 13.6436C9.21082 13.6598 8.51887 13.6534 7.84362 13.6654C7.89503 14.6431 7.86692 15.8114 7.86611 16.7969L7.86379 22.035L7.86869 25.543C7.87213 26.2236 7.90166 27.247 7.83397 27.9101C8.25814 27.8664 9.31583 27.8926 9.7712 27.8926L13.5992 27.8928L19.8332 27.8923C20.952 27.8922 22.2002 27.8647 23.3063 27.9059C23.3145 27.2977 23.3181 26.6895 23.3172 26.0812C23.3149 25.5619 23.2544 24.3584 23.411 23.914C23.9021 23.8729 24.6569 23.8961 25.1674 23.8975L27.7854 23.8944L27.7961 22.7839L27.8049 22.4887L28.6035 22.4796C28.6027 22.8341 28.674 24.3267 28.4838 24.5329C28.0226 25.0326 27.3672 25.5769 26.8452 26.0365L24.2645 28.3358C24.1526 28.4335 23.8948 28.6449 23.7558 28.6549C23.1231 28.7005 22.4233 28.679 21.7855 28.6783L17.8138 28.6764L11.0157 28.6774C9.78804 28.6775 8.28874 28.7147 7.08437 28.6491C6.99439 27.8605 7.01047 27.0076 7.00743 26.2093L7.0032 22.7731L7.00361 16.5211C7.00772 15.3897 6.96457 14.0668 7.0961 12.937C7.09949 12.9078 7.187 12.8986 7.21818 12.8918Z",
  "M10.5873 10.6478C10.7478 10.6802 11.4371 10.6701 11.651 10.6704L13.9941 10.6678L13.9914 16.8361L13.9919 18.5861C13.9921 18.9047 14.001 19.4429 13.9609 19.7483C13.5184 19.7009 12.911 19.7128 12.4508 19.7127C11.8556 19.7126 11.1672 19.6954 10.5823 19.7544C10.6177 18.3039 10.58 16.7221 10.5821 15.2615L10.5826 12.0681C10.5826 11.5995 10.5992 11.1133 10.5873 10.6478Z",
  "M9.19333 23.8638C9.48916 23.9017 10.4344 23.8979 10.758 23.8984L13.5142 23.8988C16.4291 23.9095 19.344 23.904 22.2588 23.8824C22.2508 24.1486 22.237 24.4285 22.2512 24.6933C19.9933 24.6775 17.7354 24.6734 15.4774 24.6811C13.3746 24.6695 11.2718 24.6743 9.16913 24.6953C9.16679 24.3945 9.16522 24.1652 9.19333 23.8638Z",
  "M9.18602 25.7178C9.46115 25.7573 10.2392 25.7427 10.5529 25.7428L13.1409 25.7416L22.2539 25.7401C22.2415 25.9882 22.248 26.2478 22.2502 26.497C20.558 26.5536 18.6106 26.5076 16.8896 26.5067C14.3324 26.5053 11.7304 26.5348 9.17921 26.5055C9.15197 26.2358 9.16597 25.987 9.18602 25.7178Z",
  "M22.858 12.8866C23.7325 12.8412 24.8972 12.8831 25.797 12.8744C26.5556 12.8671 27.839 12.8415 28.5403 12.9166C28.6031 13.2695 28.6487 18.3829 28.586 18.5661L28.5254 18.5934C28.4657 18.5421 28.4096 18.4871 28.3532 18.4324C28.1866 18.2707 27.9335 18.0591 27.8528 17.8383C27.7173 17.4676 27.7916 14.268 27.7899 13.6609C26.4049 13.6166 24.9973 13.6843 23.6112 13.6331C23.2896 13.6212 23.2085 13.3539 22.9954 13.1689C22.9131 13.0974 22.8356 13.0611 22.7656 12.9741L22.7739 12.9229L22.858 12.8866Z",
  "M11.5699 7.88277C11.6434 7.88023 11.7169 7.87814 11.7904 7.8765C14.2365 7.82227 13.9808 8.13296 13.9719 10.3344L13.108 10.3301C12.2938 10.3273 11.415 10.3091 10.6061 10.3306C10.6041 9.44327 10.3458 7.99668 11.5699 7.88277Z",
  "M10.7109 20.0509C11.7354 20.0679 12.8679 20.086 13.8871 20.0514C13.7344 20.3515 13.4853 20.718 13.3095 21.0327C13.2188 21.1762 13.1012 21.4224 13.0205 21.5797C12.5382 21.5491 12.0776 21.5335 11.5965 21.5953C11.3962 21.1548 10.9729 20.4847 10.7109 20.0509Z",
  "M12.3586 22.0235C12.4908 22.0132 12.4921 21.993 12.5949 22.0421C12.6588 22.2044 12.4619 22.6037 12.3462 22.6826L12.2908 22.6674C12.184 22.5482 11.919 22.2199 11.9717 22.0621C12.0478 22.0092 12.2544 22.024 12.3586 22.0235Z"
];

const PRECON_CUTOUT_PATHS = [
  "M15.6295 13.6305C15.8579 13.613 16.488 13.5722 16.625 13.7697C16.6112 14.0424 15.8304 13.9896 15.6191 13.9792C15.6657 13.8871 15.6387 13.7383 15.6295 13.6305Z",
  "M18.3706 13.257C18.8069 13.3381 21.1414 15.7647 21.6334 16.2432L23.7171 18.2656C23.9973 18.5413 24.784 19.2489 24.9124 19.5528C24.8908 19.665 24.9005 19.6297 24.8205 19.7228C24.379 19.8143 19.2562 19.8314 18.8216 19.7355C18.6613 19.7001 18.505 19.5932 18.4176 19.4574C18.344 19.3431 18.3131 19.2103 18.2996 19.0774C18.2266 18.3608 18.2817 17.3963 18.2814 16.6592L18.2817 14.8766C18.2821 14.3806 18.2598 13.7312 18.3706 13.257Z",
  "M24.1198 24.6531C24.3272 24.6812 24.9456 24.6696 25.1772 24.6693L27.1973 24.6649C26.7525 25.083 26.2375 25.4936 25.7684 25.9302C25.5466 26.1342 25.2705 26.3559 25.0402 26.5612C24.8165 26.7606 24.4004 27.1783 24.1564 27.3102L24.1107 27.289C24.0763 27.0589 24.0987 26.5751 24.102 26.3182L24.1198 24.6531Z"
];

/**
 * Precon glyph — drafting tools, no tile. A filled shape, so the colour comes
 * from a `fill-*` class in `className`.
 */
export default function PreconCiqIcon({
  size = 12,
  className = "fill-black",
  opacity = "0.6"
}: {
  size?: number;
  className?: string;
  opacity?: string;
}) {
  // Per-instance id so several icons on one page don't share a mask.
  const maskId = `precon-mask-${useId().replace(/:/g, "")}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="7 5.8 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <mask
          id={maskId}
          maskUnits="userSpaceOnUse"
          x="7"
          y="5.8"
          width="24"
          height="24"
        >
          <rect x="7" y="5.8" width="24" height="24" fill="white" />
          {PRECON_CUTOUT_PATHS.map((d) => (
            <path key={d} d={d} fill="black" />
          ))}
        </mask>
      </defs>
      <g mask={`url(#${maskId})`} fillOpacity={opacity}>
        {PRECON_GLYPH_PATHS.map((d) => (
          <path key={d} d={d} />
        ))}
      </g>
    </svg>
  );
}

/**
 * Precon phase badge — the same drafting tools on their fixed-colour tile.
 * Design: 36×36 container (#2E3199) + glyph (#D746FF). Used by CiqIconBox.
 */
export function PreconTileCiqIcon({
  size = 36,
  className = ""
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V32C36 34.2091 34.2091 36 32 36H4C1.79086 36 0 34.2091 0 32V4Z"
        fill="#2E3199"
      />
      {PRECON_GLYPH_PATHS.map((d) => (
        <path key={d} d={d} fill="#D746FF" />
      ))}
      {PRECON_CUTOUT_PATHS.map((d) => (
        <path key={d} d={d} fill="#2E3199" />
      ))}
    </svg>
  );
}
